import React, { useEffect, useContext } from 'react'
import { Field as FieldConf, FieldType, PresetSelector, conf } from 'src/config'
import * as types from '../../types'
import { TextField, Box, Switch, FormControl, FormControlLabel, InputLabel, FormHelperText, Input, OutlinedInput, Select, MenuItem, Typography } from '@mui/material'
import BooleanField from './fields/BooleanField'
import DropdownField from './fields/DropdownField'
import SimpleTextField from './fields/SimpleTextField'
import PasswordField from './fields/PasswordField'
import DateTimeField from './fields/DateTimeField'
import DateField from './fields/DateField'
import { Scope as ExplorerScope, ExplorerContext } from '../../components/Entity';
import _ from 'lodash'
import { getResourceLabel } from 'src/config'


const AbstractField: React.FC<{
    field: FieldConf,
    value?: types.SimpleValue,
    onChange: (value: types.Value) => void,
    errors?: types.Error[],
    entity?: types.Entity
    // options?: types.EntityOptions
}> = ({
    field,
    value,
    onChange,
    errors = [],
    entity
    // options
}) => {
        const { name, type, valuesSelector, values, description } = field;
        const isLocked: boolean = entity?.locked || false;

        const renderField = () => {

            if (type === FieldType.BOOLEAN) {
                return <BooleanField
                    field={field}
                    value={value}
                    onChange={onChange}
                    disabled={isLocked}
                />
            } else if (valuesSelector == PresetSelector.RESOURCES) {
                const acc: { [key: string]: string } = {};

                const resources = conf.getSchema().resources;

                const options = _.keys(resources).reduce((acc, name) => {
                    acc[name] = getResourceLabel(resources[name]);
                    return acc;
                }, acc);

                return <>
                    <DropdownField
                        field={field}
                        value={value != null ? value.toString() : ''}
                        onChange={onChange}
                        options={options}
                        disabled={isLocked}
                    />
                </>
            } else if (values != null && values.length > 0) {
                const acc: { [key: string]: string } = {};
                const options = values.reduce((acc, val) => {
                    acc[val] = val;
                    return acc;
                }, acc);
                return <>
                    <DropdownField
                        field={field}
                        value={value != null ? value.toString() : ''}
                        onChange={onChange}
                        options={options}
                        disabled={isLocked}
                    />
                </>
            } else if (type === FieldType.PASSWORD) {
                return <PasswordField
                    field={field}
                    value={value}
                    onChange={onChange}
                    disabled={isLocked}
                />
            } else if (type === FieldType.DATE) {
                return <DateField
                    field={field}
                    value={value}
                    onChange={onChange}
                    disabled={isLocked}
                    errors={errors}
                />
            } else if (type === FieldType.DATE_TIME) {
                return <DateTimeField
                    field={field}
                    value={value}
                    onChange={onChange}
                    disabled={isLocked}
                    errors={errors}
                />
            } else {
                return <SimpleTextField
                    field={field}
                    value={value}
                    onChange={onChange}
                    disabled={isLocked}
                    multiline={type == FieldType.TEXT}
                    errors={errors}
                />
            }
        }

        return (
            <FormControl
                sx={{
                    mt: 1,
                    mb: 1,
                }}
                // error={errors.length > 0}
                size='small'
                fullWidth
            >
                {
                    renderField()
                }
                {
                    errors.map((err, index) => (
                        <FormHelperText
                            id={'field-error-' + name}
                            key={index}
                            sx={{ color: theme => theme.palette.error.main }}
                        >
                            {err.message}
                        </FormHelperText>
                    ))
                }
                {
                    description && <FormHelperText
                        id={'field-description-' + name}
                        sx={{ color: theme => theme.palette.info.dark }}
                    >
                        {description}
                    </FormHelperText>
                }
            </FormControl>
        )
    }

export default AbstractField;